
import { useState, useRef } from "react";
import { Investor, Contact } from "@/types/investor";

export const useInvestorData = () => {
  const [investors, setInvestors] = useState<Investor[]>([]);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [processedIds, setProcessedIds] = useState<Set<string>>(new Set());
  const [selectedInvestor, setSelectedInvestor] = useState<Investor | null>(null);
  const [businessInfo, setBusinessInfo] = useState("");
  const [relevanceContext, setRelevanceContext] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false);
  
  // Add flags to prevent duplicate saves and syncs
  const initialDataLoaded = useRef(false);
  const isSaving = useRef(false);
  const isSyncing = useRef(false);
  
  return {
    // Data state
    investors,
    setInvestors,
    contacts,
    setContacts,
    processedIds,
    setProcessedIds,
    selectedInvestor,
    setSelectedInvestor,
    businessInfo,
    setBusinessInfo,
    relevanceContext,
    setRelevanceContext,
    
    // Loading state
    isLoadingData,
    setIsLoadingData,
    
    // Reference flags
    initialDataLoaded,
    isSaving,
    isSyncing
  };
};
